import { render, staticRenderFns } from "./fangTan.vue?vue&type=template&id=6df63d65&scoped=true&"
import script from "./fangTan.vue?vue&type=script&lang=js&"
export * from "./fangTan.vue?vue&type=script&lang=js&"
import style0 from "./fangTan.vue?vue&type=style&index=0&id=6df63d65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df63d65",
  null
  
)

export default component.exports